import * as amplitude from "@amplitude/analytics-browser";

interface EventParams {
  action: string;
  label?: string;
  value?: number;
}

const hasStatisticsConsent = () => {
  const cookieYesConsent = window.getCkyConsent ? window.getCkyConsent() : null;
  const consentViaCookieYes =
    cookieYesConsent && cookieYesConsent.categories.analytics;
  const noCmp = !window.getCkyConsent;

  return noCmp || consentViaCookieYes;
};

export const amplitudeEventFactory =
  (category: string): any =>
  ({ action, ...params }: EventParams): void => {
    if (!hasStatisticsConsent()) {
      return;
    }

    amplitude.track(action, { ...params, category });
  };
